module.exports = __webpack_public_path__ + "static/media/visual.3f913d87.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/visual.gif
// module id = 434
// module chunks = 0